import PropTypes from 'prop-types';

const Swap = ({ color, size, ...props }) => (
    <svg viewBox="0 0 20 20" width={size} height={size} {...props}>
        <path
            d="M3.576 7.252h11.04L12.398 9.47c-.478.444-.112 1.303.53 1.28a.75.75 0 0 0 .53-.22l3.497-3.498a.79.79 0 0 0 .163-.817 1.6 1.6 0 0 0-.163-.243l-3.498-3.498c-.707-.684-1.745.35-1.06 1.06l2.219 2.218H3.576c-.978.015-.99 1.482 0 1.5M16.425 12.75H5.385l2.22-2.22c.683-.705-.352-1.746-1.06-1.06L3.045 12.97c-.209.224-.28.568-.144.847.038.076.092.146.144.213l3.498 3.498c.707.683 1.746-.35 1.06-1.06l-2.218-2.219h11.04c.977-.014.99-1.482 0-1.499"
            fill={color}
        />
    </svg>
);

export default Swap;

Swap.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
